// @core/api/endpoints/subscription/create_feature_usage_record.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateFeatureUsageRecordRequest,
  CreateFeatureUsageRecordResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Record feature usage
 * Records metered feature usage for billing purposes. Tracks consumption against subscription limits and triggers overage alerts.
 */
export async function CreateFeatureUsageRecord(
  subscription_id: string,
  data: CreateFeatureUsageRecordRequest,
  options?: RequestOptions
): Promise<CreateFeatureUsageRecordResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/subscriptions/:subscription_id/usage`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  const requestOptions = options;
  return client.post<CreateFeatureUsageRecordResponse>(requestPath, data, requestOptions);
}
